export var LoadMoreIndicatorType;
(function (LoadMoreIndicatorType) {
    LoadMoreIndicatorType[LoadMoreIndicatorType["NoData"] = 0] = "NoData";
    LoadMoreIndicatorType[LoadMoreIndicatorType["Loading"] = 1] = "Loading";
    LoadMoreIndicatorType[LoadMoreIndicatorType["Complete"] = 2] = "Complete";
})(LoadMoreIndicatorType || (LoadMoreIndicatorType = {}));
